<script setup>
import { computed, ref } from 'vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import { useCartDataProvider } from '@vueApp/hooks/useCartDataProvider';
import IAcquiringsButton from '@components/IAcquiringsButton/IAcquiringsButton.vue';
import IModal from '@components/IModal/IModal.vue';

translator.getLanguages();
const { isFakePayment } = useCartDataProvider();

const props = defineProps({
  order: {
    type: Object,
    required: true,
  },
  smallBtn: {
    type: Boolean,
    default: false,
  },
});

const getPayUrl = () => {
  if (isFakePayment) return `/order/fake?id=${props.order.id}`;
  return `/pay/pay?id=${props.order.id}`;
};

const firstEventId = computed(() => props.order.cases[0].id);

const eventType = computed(() => props.order.cases[0].type);

const ticketsCount = computed(() => props.order.cases.reduce(
  (accumulator, currentEvent) => accumulator + currentEvent.tickets.length,
  0,
));

const acquiringsReversed = computed(() => [...props.order.acquirings].reverse());

const isAcquiringError = ref({
  isAcquiringError: false,
  errorMessage: '',
});

function updatePage() {
  window.location.reload();
}

function setAcquiringError(errorObject) {
  isAcquiringError.value = errorObject;
}
</script>

<template>
  <div class="i-acquirings">
    <template v-if="!(order.acquirings.length > 1)">
      <i-acquirings-button
        :url="getPayUrl()"
        :first-event-id="firstEventId"
        :event-type="eventType"
        :options="{ sum: order.summaryPrice, id: 0 }"
      />
    </template>
    <template v-else>
      <i-acquirings-button
        v-for="acquiring in acquiringsReversed"
        :key="acquiring.id"
        :first-event-id="firstEventId"
        :event-type="eventType"
        :options="{ ...acquiring, orderId: order.id }"
        :small-btn="smallBtn"
        :tickets-count="ticketsCount"
        :url="getPayUrl()"
        @set-acquiring-error="errorState => setAcquiringError(errorState)"
      />
    </template>
  </div>
  <i-modal v-model="isAcquiringError.isAcquiringError" @hide="updatePage">
    <template #body>
      {{
        isAcquiringError.errorMessage ??
          translator.t("main", "An error occurred when paying for the order!")
      }}
    </template>
  </i-modal>
</template>

<style scoped lang="scss">
.i-acquirings {
  display: flex;
  justify-content: flex-end;

  & > * {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: $screen-xs) {
    width: 100%;
    flex-direction: column;

    & > * {
      margin-right: 0;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
